import { Link } from "react-router-dom";
import { Box, Grid, styled } from "@mui/system";
import Toolbar from "@mui/material/Toolbar";
import {
  SnackbarOrigin,
  TableHead,
  Tooltip,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  FaAnglesLeft,
  FaAnglesRight,
  FaBusinessTime,
  FaCertificate,
  FaCircleQuestion,
  FaFolder,
  FaHouseChimney,
  FaLock,
  FaMagnifyingGlassLocation,
  FaUsers,
  FaCircleUser,
  FaFileArrowUp,
  FaHeadset,
  FaRegBell,
  FaCircleInfo,
  FaCircleXmark,
  FaXmark,
  FaCircleCheck,
  FaTableList,
  FaCircle,
  FaBook,
} from "react-icons/fa6";
import { FaCalculator, FaCheckCircle, FaTimesCircle } from "react-icons/fa";


import fontWeight from "../../styles/mui/fontWeight";
import colors from "../../styles/colors/colors";
import others from "../../styles/colors/others";

export const HeaderToolbar: any = styled(Toolbar)((props) => ({
  minHeight: "5.6rem",
  display: "flex",
  justifyContent: "space-between",
  [props.theme.breakpoints.up("sm")]: {
    minHeight: "5.6rem",
  },
  boxShadow: "0rem 0.25rem 0.625rem rgba(0, 0, 0, 0.2)",
}));

export const PortalUpdate = {
  textAlign: "left",
  padding: "0.3rem 2.2rem",
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  height: "2.8rem",
  background: colors.backgroundColor[15],
};

export const PortalUpdateClose = {
  textAlign: "end",
  padding: "0.3rem 2.2rem",
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
  height: "2.8rem",
  background: colors.backgroundColor[15],
};

export const LogoLink = styled(Link)(() => ({
  display: "flex",
  alignItems: "center",
  padding: "0 0 0 2rem",
  height: "3rem",
}));

export const LogoImg = styled("img")(() => ({
  height: "3rem",
}));

export const FaCircleUserIcon: any = styled(FaCircleUser as React.ComponentType)(() => ({
  marginRight: "0.75rem",
  color: colors.black[1],
  fontSize: "2rem",
}));

export const FaHeadsetIcon: any = styled(FaHeadset as React.ComponentType)(() => ({
  marginRight: "0.95rem",
  color: colors.arrowIcon[1],
  fontSize: "1.4rem",
  "&:hover": {
    color: colors.black[13],
  },
  cursor: "pointer",
}));

export const FaRegBellIcon: any = styled(FaRegBell as React.ComponentType)(() => ({
  marginRight: "0.3rem",
  color: colors.black[1],
  fontSize: "1.4rem",
}));

export const UserDetails = styled(Box)(() => ({
  display: "flex",
  color: colors.black[1],
  fontSize: "2rem",
  flexDirection: "column",
}));
export const WordOverflow = {
  wordBreak: "break-word",
  overflowWrap: "break-word"
}
export const UserDetailsText = styled(Typography)(() => ({
  color: colors.black[1],
  variant: "h2",
}));

export const UserDetailsTextStyle = (type: number) => ({
  fontSize: type === 1 ? "1rem" : "0.8rem",
  fontWeight: fontWeight[6],
  paddingBottom: type === 1 ? "0.5rem" : "0",
  color: colors.black[1],
  textTransform: type === 1 ? "capitalize" : "none",
});

export const TriangleIndicator = styled("div")(() => ({
  width: 0,
  height: 0,
  borderLeft: "2rem solid transparent", // Half of the desired width
  borderRight: "2rem solid transparent", // Half of the desired width
  borderBottom: "2rem solid #c2e1f5", // Triangle color and height
  position: "absolute",
  left: "6.2rem", // Adjust position as needed
  top: "2rem", // Adjust position as needed
  zIndex: 10,
}));

export const IconStyle = (
  open: boolean,
  selectedMenuPath: string,
  menuPath: string
) => ({
  marginRight: open ? "0.8rem" : "0",
  color: selectedMenuPath === menuPath ? colors.fonts[30] : colors.grey[3],
});

export const CustomMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: colors.backgrounds[8],
    marginTop: "1.68rem",
  },
  ".css-1toxriw-MuiList-root-MuiMenu-list": {
    listStyle: "none",
    margin: "0.1875rem",
    padding: "0.125rem",
    position: "relative",
    outline: 0,
  },
  ".css-ubifyk": {
    padding: "0.25rem 0.25rem",
  },
}));

export const MenuTextColorChange = (
  selectedMenuPath: string,
  menuPath: string
) => ({
  color: selectedMenuPath === menuPath ? colors.fonts[30] : colors.fonts[31],
  "&:hover": {
    backgroundColor: colors.white[1],
    color: colors.black[1],
  },
  marginBottom: "0.4rem",
});

export const MenuGrid = {
  paddingTop: "1rem",
  position: "absolute",
};

export const MenuOuterBoxStyle = (open: boolean) => ({
  margin: "2.8rem 1rem 4rem 1rem",
  minHeight: "52vh",
  maxHeight: "52vh",
  width: open ? "16rem" : "4.7rem",
  backgroundColor: "white",
  border: "0.0625rem solid #ddd",
  transition: "width 0.3s",
  borderRadius: "0.3125rem",
});

export const FaAnglesLeftIcon: any = styled(FaAnglesLeft as React.ComponentType)(() => ({
  color: colors.arrowIcon[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaAnglesRightIcon: any = styled(FaAnglesRight as React.ComponentType)(() => ({
  color: colors.arrowIcon[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaCertificateIcon: any = styled(FaCertificate as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaCircleQuestionIcon: any = styled(FaCircleQuestion as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaFolderIcon: any = styled(FaFolder as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaHouseChimneyIcon: any = styled(FaHouseChimney as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaLockIcon: any = styled(FaLock as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaMagnifyingGlassLocationIcon: any = styled(FaMagnifyingGlassLocation as React.ComponentType)(
  () => ({
    color: others.gray[1],
    fontSize: "1rem",
    marginRight: "0.417rem",
  })
 );
  
  export const FaCalculatorIcon: any = styled(FaCalculator as React.ComponentType)(
  () => ({
    color: others.gray[1],
    fontSize: "1rem",
    marginRight: "0.417rem",
  })
 ); 

export const FaBusinessTimeIcon: any = styled(FaBusinessTime as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaUsersIcon: any = styled(FaUsers as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaCircleCheckIcon: any = styled(FaCircleCheck as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaFileArrowUpIcon: any = styled(FaFileArrowUp as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const FaTableListIcon: any = styled(FaTableList as React.ComponentType)(() => ({
  color: others.gray[1],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const ParentMenuItemBox = {
  background: colors.backgroundColor[16],
  width: "auto",
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  flexDirection: "column",
};

export const CustomMenuItem = styled(MenuItem)(() => ({
  color: colors.black[13],
  zIndex: 1,
  padding: "0.7rem 0 0.7rem 1.4rem",
  width: "100%",
}));

export const CustomTooltip = styled(Tooltip)(() => ({
  "& .MuiTooltip-tooltip": {
    boxShadow: colors.white[1],
    backgroundColor: colors.white[1],
    border: "none",
  },
  "& .MuiTooltip-arrow": {
    color: colors.white[1],
  },
}));

export const IconButtonStyle = {
  // position: "absolute",
  top: 0.5,
  right: -10,
};

export const IconGrid = {
  display: "flex",
  justifyContent: "end",
};

export const UpdateTextStyle = {
  fontStyle: "italic",
};

export const FaCircleInfoIcon: any = styled(FaCircleInfo as React.ComponentType)(() => ({
  color: colors.white[1],
  fontSize: "1.2rem",
  marginRight: "0.417rem",
}));

export const FaCircleXmarkIcon: any = styled(FaCircleXmark as React.ComponentType)(() => ({
  color: colors.white[1],
  fontSize: "1.2rem",
  marginRight: "0.417rem",
}));

export const FaCircleIcon: any = styled(FaCircle as React.ComponentType)(() => ({
  color: colors.portalColor[2],
  fontSize: "0.5rem"
}));

export const FaXmarkIcon: any = styled(FaXmark as React.ComponentType)(() => ({
  color: colors.black[10],
  fontSize: "1rem",
  marginRight: "0.417rem",
}));

export const MainBox = {
  background: "#dbf6fd",
  width: "100%",
  height: "100%",
};

export const HorizontalDivider = () => ({
  color: colors.dropShadow[4],
  margin: "0.72rem 0 0.72rem 0",
});

export const InputStyle = {
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: "18rem",
  height: "2.3rem",
  "& .MuiOutlinedInput-root": {
    height: "2.3rem",
    "& input": {
      marginLeft: "0.417rem",
      height: "2.3rem",
      borderRadius: "0.0625rem",
      padding: "0",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.black[13],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.black[13],
    },
  },
};

export const BackdropSection = () => ({
  zIndex: 1300,
  backgroundColor: colors.backgroundColor[19],
});

export const LoaderStyle = () => ({
  width: "100px",
  height: "100px",
  animation: "spin 2s linear infinite",
});

export const ButtonVerifyStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.primary.main,
};
export const ButtonClearStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.primary.main,
};

export const ButtonResendStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.backgroundColor[15],
};

export const ButtonCloseStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.backgroundColor[17],
  color: colors.white[1],
};

export const MfaModalBox = () => ({
  position: "relative",
  width: "33%",
  backgroundColor: "background.paper",
  padding: "1rem",
});

export const ModalGrid = () => ({
  marginTop: "0.9rem",
  marginBottom: "2.1rem",
});
export const ModalGrid2 = () => ({
  marginTop: "0.9rem",
  marginBottom: "0",
});

export const CustomMenuItemBox = () => ({
  width: "11rem",
});

export const UserDetailsTextGrid = () => ({
  width: "12rem",
});

export const UserDetailsTitle = () => ({
  paddingBottom: "0.5rem",
  fontSize: "1.4rem",
});

export const UserDetailsGridContainer = () => ({
  width: "18rem",
});

export const SnackbarAnchorOrigin: SnackbarOrigin = {
  horizontal: "center",
  vertical: "bottom",
};

export const UnauthenticatedContainer = () => ({
  padding: "1rem",
});

export const CollapsibleNavbar = () => ({
  padding: "1rem 0.6rem",
});

export const Headcell100 = {
  minWidth: "6.5rem",
  width: "6.5rem",
  backgroundColor: "#d6d6d6",
};
export const Headcell10 = {
  minWidth: "0.5rem",
  width: "0.5rem",
  backgroundColor: "#d6d6d6",
};
export const Headcell12 = {
  minWidth: "4rem",
  width: "4rem",
  backgroundColor: "#d6d6d6",
};

export const Headcell11 = {
  minWidth: "4rem",
  width: "2rem",
  backgroundColor: "#d6d6d6",
};

export const Headcell200 = {
  minWidth: "9.5rem",
  width: "9.5rem",
  backgroundColor: "#d6d6d6",
};

export const Headcell250 = {
  minWidth: "10.2rem",
  width: "10.2rem",
  backgroundColor: "#d6d6d6",
};

export const ContainerStyle = {
  height: "60vh",
  "&::-webkit-scrollbar": {
    width: "0.5rem",
    height: "0.2rem",
  },
  "&::-webkit-scrollbar-track": {
    width: 0.1,
    marginLeft: "10rem",
    marginRight: "50rem",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: colors.black[7],
    borderRadius: 0.1,
    width: 0.1,
  },
};

export const StyledTableHead = styled(TableHead)(() => ({
  backgroundColor: colors.grey[1],
  zIndex: 1,
  borderBottom: "unset",
  "& th:first-of-type": {
    borderRadius: "0.2rem 0 0 0.2rem",
    borderBottom: "none",
  },
  "& th:last-child": {
    borderRadius: "0 0.2rem 0.2rem 0",
    borderBottom: "none",
  },
}));

export const tableCell = {
  borderBottom: "unset",
  backgroundColor: "#d6d6d6",
};

export const tableCellDynamic = (
  isFirstData: boolean,
  isLastData: boolean
) => ({
  borderLeft: isFirstData ? `1px solid ${colors.borders[2]}` : "none",
  borderBottom: isLastData ? "unset" : `1px solid ${colors.dropShadow[1]}`,
  position: "relative",
});

export const tableCellDynamic2 = (
  isFirstData: boolean,
  isLastData: boolean
) => ({
  borderLeft: !isFirstData ? `1px solid ${colors.borders[2]}` : "none",
  borderBottom: isLastData ? "unset" : `1px solid ${colors.dropShadow[1]}`,
  position: "relative",
});
export const tableCellDynamicBorderTop = () => ({
  borderBottom: "unset",
  position: "relative",
});

export const NoRecordsCell = {
  padding: "0.3rem 4rem",
};

export const PaginationGrid = () => ({
  marginTop: "0.2rem",
  paddingBottom: "1rem",
});

export const LeftNavStickyContainer = () => ({
  display: "flex",
  // height: "calc(90vh - 64px)",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "8px", // Set the width of the scrollbar
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888", // Thumb color
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555", // Color on hover
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f1f1", // Track background
    borderRadius: "10px",
  },
});

export const HeaderStickyContainer = {
  position: "sticky",
  top: 2,
  backgroundColor: "white",
  zIndex: 1000,
};

export const TextAreaStyle = {
  width: "100%",
};

export const IconFaTimesCircle = styled(FaTimesCircle)(() => ({
  color: colors.red[80],
  opacity: 2,
  width: "2rem",
  height: "2rem",
  cursor: "pointer",
}));

export const ModalIconBtnStyle = {
  position: "relative",
  width: "100%",
  height: "100%",
  p: 2,
  overflow: "auto",
};

export const DialogStyle = {
  height: "98%",
  width: "98%",
  outline: 0,
  alignItems: "center",
  margin: ".5rem auto 0 auto",
};

export const ModalCloseIcon = {
  position: "absolute",
  top: 12,
  right: 12,
  zIndex: 2,
};

export const ButtonSureStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.portalColor[14],
  color: colors.white[1],
};

export const ModalOuterContainer = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const TextLabelFontStyle = () => ({
  fontSize: "20px",
});

export const SubMenuLink = () => ({
  padding: "0.5rem 0",
  textDecoration: "none",
  color: colors.fonts[31],
  fontSize: "1rem",
  fontWeight: fontWeight[2],
  "&:hover": {
    textDecoration: "underline",
  },
});

export const SubMenuItem = () => ({
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&:focus": {
    backgroundColor: "transparent",
  },
});

export const LeftNavBackground = {
  backgroundColor: colors.white[1],
  borderRadius: 1,
};

export const InformationTestStyle = {
  fontWeight: fontWeight[5],
  color: colors.red[80],
};

export const TextFieldStyle = () => ({
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  height: "2.1rem",
  marginRight: "1.25rem",
  "& .MuiOutlinedInput-root": {
    height: "2.1rem",
    "& input": {
      marginLeft: "0.7rem",
      height: "2.1rem",
      borderRadius: "0.0625rem",
      padding: "0",
      width: "100% !important",
      fontSize: "0.8rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.portalColor[16],
      border: `3px solid ${colors.portalColor[16]}`,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.grey[4],
    },
  },
});

export const UserRegistrationBox = () => ({
  position: "relative",
  backgroundColor: "background.paper",
  borderRadius: "1.5rem",
  padding: "1rem",
  display: "flex",
  justContent: 'center'
});

export const UserRegistrationGridContainer = () => ({
  display: "flex",
  flexDirection: 'column',
  background: colors.white[1],
  margin: "1.25rem",
  padding: "1.25rem",
  borderRadius: "0.9rem"
});

export const DisplayItemCenter = (flag?: boolean) => ({
  display: "flex",
  justifyContent: flag ? "left" :"center",
  marginBottom: "0.2rem",
});

export const ForgotPasswordModalBox = () => ({
  position: "relative",
  width: "33%",
  backgroundColor: "background.paper",
  borderRadius: "1.5rem",
  padding: "1rem",
});

export const ForgotPasswordGridContainer = () => ({
  width: "100%",
  marginBottom: "15%",
});

export const CancelButton = {
  backgroundColor: colors.backgroundColor[17],
};

export const ErrorStyle = { color: colors.red[100], marginBottom: 2 }
export const ErrorBox = styled(Box)(() => ({
  justifyContent: "center",
  width: "500px"
}));

export const GridLayout = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  height: "100vh",
}));

export const GridItem = styled(Grid)(() => ({
  minHeight: "18rem",
  minWidth: "50%",
  backgroundColor: colors.primary.light,
  borderRadius: "0.9rem",
  padding: "2rem",
  alignSelf: "center",
  boxShadow: `0.1rem 0.1rem 0.1rem 0.1rem ${colors.dropShadow[1]}`,
}));

export const OuterGrid = () => ({
  backgroundColor: colors.backgroundColor[14]
});

export const HeaderToolbarPatient: any = styled(Toolbar)((props) => ({
  minHeight: "2.8rem",
  display: "flex",
  backgroundColor: others.HeaderMenu[2],
  justifyContent: "space-between",
  [props.theme.breakpoints.up("sm")]: {
    minHeight: "2.8rem",
  },
}));

export const IconFaInfoAlt: any = styled(FaCheckCircle as React.ComponentType)(() => ({
  color: colors.fonts[18],
  cursor: "pointer",
  width: "1rem",
  height: "1rem",
}));

export const NavLine = () => ({
  width: "6rem",
  height: 0,
  border: `1px dotted ${colors.circleBorder.border}`,
  zIndex: 1,
});

export const StageCircle = () => ({
  border: `1px solid ${colors.circleBorder.border}`,
  borderRadius: "100%",
  width: "1.3rem",
  height: "1.3rem",
  lineHeight: "1.3rem",
  textAlign: "center",
  zIndex: 2,
  opacity: 0.8,
  borderColor: "none",
  backgroundColor: colors.white[1],
});

export const priorAuthHeader = {
  backgroundColor: colors.backgroundColor[10],
  padding: "0.5rem 0 2rem 0",
  minHeight: "5.4rem",
  alignItems: "center",
};

export const PanelSectionBox = styled(Box)(() => ({
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  backgroundColor: colors.white[1],
  borderRadius: "10px",
  marginBottom: "1rem",
}));

export const PatientInfoReferralGrid = () => ({
  display: "block",
  padding: "0 0.8rem 0 1.8rem",
  zIndex: 10,
  position: "relative",
  top: "-1.2rem",
  width: "99%",
});

export const PatientInfoPanelBox = styled(Box)(() => ({
  padding: "1.2rem 1.5rem 1rem 1.5rem",
}));

export const PatientInfoDivider = {
  margin: "0 1.2rem",
  height: "2rem",
  align: "left",
};

export const HeaderUserDetails = () => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  gap: "0.3rem",
});

export const HeaderContainer = () => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "center",
  paddingTop: "0.2rem",
});

export const PatientDetailsContainer = () => ({
  backgroundColor: colors.white[1],
  width: "100%",
  display: "flex",
  alignItems: "center",
  border: `1px solid ${colors.borders[2]}`,
  borderRadius: "0.3rem",
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
});

export const PatientDetailsDivider = () => ({
  border: `0.5px solid ${colors.borders[2]}`,
});

export const EligibilityBox = () => ({
  border: `1px solid ${colors.circleBorder.border}`,
  borderRadius: "100%",
  padding: "0.12rem 0.1rem 0.1rem 0.13rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.white[1],
});

export const StatusContainer = () => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  paddingRight: "2rem",
});

export const StickyContainer = () => ({
  display: "flex",
  justifyContent: "center",
  padding: "0  1.5rem",
  top: "2.5rem",
  zIndex: 2,
});

export const FaBookIcon: any = styled(FaBook as React.ComponentType)(() => ({
  marginRight: "0.95rem",
  color: colors.black[1],
  fontSize: "1.4rem",
}));

export const NotificationListBox = () => ({
  position: "absolute",
  top: 70,
  right: 30,
  width: 440,
  maxHeight: 400,
  bgcolor: "background.paper",
  boxShadow: 3,
  borderRadius: 2,
  zIndex: 1300,
  p: 0,
  overflow: "hidden",
  border: `1px solid ${colors.borders[11]}`,
});

export const NotificationHeaderGridContainer = () => ({
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${colors.borders[11]}`,
  px: 2,
  py: 1.5,
  background: colors.white[1],
  position: "sticky",
  top: 0,
  zIndex: 1,
});

export const NotificationListBoxSection = ({
  display: "flex",
  mb: 2,
  p: 2,
  border: `1px solid ${colors.dropShadow[2]}`,
});

export const RenderFieldValueStyle = ({
  maxWidth: "320px",
  wordBreak: "break-word",
  whiteSpace: "pre-line",
});
export const SsoModalStyle ={ color: colors.primary.main, textDecoration: "underline" }
export const ProgressBarStyle = { width: "100%", mt: 1, display: "flex", alignItems: "center", gap: 1 }

  export const FaHpsIcon: any = styled(FaCalculator as React.ComponentType)(
  () => ({
    color: others.gray[1],
    fontSize: "1rem",
    marginRight: "0.417rem",
  })
 );

export const ErrorListStyle = ({
  m: 0,
  pl: "1.25rem",
  listStyleType: "disc",
  '& .MuiListItem-root': {
    display: "list-item",
    fontSize: "1rem",
    lineHeight: 1.5,
    mb: "0.25rem",
    p: 0,
  },
  '& .MuiListItemText-primary':{
    m: 0,
    fontSize: "1rem",
  },
});